<!-- 发布管理 -->
<template>
  <div class="box" ref="box">
    <div class="left">
      <!--左侧div内容-->
      <el-card class="wiki-part" style="overflow: scroll;overflow-x: hidden;">
        <div class="clearfix mb-10">
          <div>
            <el-input
              v-model="filterText"
              placeholder="请输入关键字"
              style="width: 100%"
            ></el-input>
          </div>
        </div>

        <el-tree
          ref="catalogueTree"
          :data="catalogueList"
          :props="defaultProps"
          :filter-node-method="filterNode"
          :highlight-current="true"
          :expand-on-click-node="false"
          :default-expanded-keys="expandedKeys"
          :current-node-key="currentKey"
          :render-content="onRenderContent"
          class="filter-tree"
          node-key="ID"
          @node-click="clickNode"
        ></el-tree>
      </el-card>
    </div>
    <div class="resize" title="收缩侧边栏">⋮</div>
    <div class="mid">
      <!--右侧div内容-->
      <el-card class="wiki-mid" style="overflow: scroll;overflow-x: hidden;">
        <item-publish-detail
          :catalogueID="catalogueActiveData.ID"
          :group="group"
          :indexName="indexName"
          :visible.sync="publishVisible"
          v-if="showPublishWiki"
        />
        <item-detail
          :businessGroup="catalogueActiveData.BusinessGroup"
          :wikiID="catalogueActiveData.WikiID"
          :indexName="indexName"
          v-if="showWiki"
        />
        <div v-if="showUrl">
          <div style="padding: 10px 20px 0 20px; float: right" v-if="!spilt">
            <!-- <el-button class="wp-but" @click="Popup">弹出页面</el-button> -->
            <el-link type="primary">
              <a
                target="_self"
                class="buttonText"
                @click="Popup"
                >弹出页面</a
              >
            </el-link>
          </div>
          <iframe
            style="width: 100%; height: 720px"
            :src="catalogueActiveData.Url"
            allowfullscreen="allowfullscreen"
            frameborder="0"
            data-id="1"
          ></iframe>
        </div>
        <item-publish-software
          :softID="catalogueActiveData.SoftID"
          :indexName="indexName"
          :visible.sync="publishVisible"
          v-if="showSoftware"
        />
      </el-card>
    </div>
  </div>
</template>

<script>
import ItemPublishDetail from "../publishManage/view-publish-detail.vue";
import ItemPublishSoftware from "./view-publish-dcisoftware.vue";
import ItemDetail from "../publishManage/view-detail.vue";

export default {
  components: {
    ItemPublishDetail,
    ItemPublishSoftware,
    ItemDetail,
  },
  data() {
    return {
      group: 0, //业务组类型 0.嵌入式 1.工控
      //===================左边树===================
      filterText: "", //检索目录
      catalogueList: [], //树的数据源，只有根节点，子节点在根节点children中
      defaultProps: {
        label: "Title",
        children: "Children",
      },
      expandedKeys: [], //id
      currentKey: "",
      catalogueActiveData: {}, //当前选中的节点信息
      lastKeyHighlight: "", // 最终要高亮的值，以前高亮之后再拉数据没有关系，现在不行了，只能先拉数据再高亮
      catalogueSubmitDisable: false,
      catalogueSelectList: [], //目录选择列表，所有节点列表
      spanceNum: 0,
      treePager: {
        total: 0,
        page: 1,
        size: -1,
      },
      indexName: "",
      //===================右边部分===================
      showPublishWiki: false,
      showWiki: false,
      showUrl: false,
      showSoftware: false,
      publishVisible: true,
    };
  },
  created() {
    this.group = this.$route.meta.group;
    this.getCatalogueTree();
  },
  watch: {
    filterText: {
      handler() {
        // this.$refs.catalogueTree.filter(val);
        this.catalogueSelectList = [];
        this.catalogueList = [];
        this.catalogueActiveData = {};
        this.getCatalogueTree();
      },
    },
  },
  mounted() {
    this.dragControllerDiv();
  },
  methods: {
    //===================左边树===================
    //获取目录树
    getCatalogueTree() {
      this.catalogueSelectList = [];
      this.$axios
        .get(
          this.group === 0 ? "dci/publish/catalogue" : "ipc/publish/catalogue",
          {
            params: {
              where: {
                BusinessGroup: this.group,
                Status: 1, //发布的
              },
              return_tree: 1,
              ...this.treePager,
              key: this.filterText,
              with: ["Parent", "PublishWiki", "Wiki.Wikicat"],
            },
          }
        )
        .then((response) => {
          response.data.forEach((ele) => {
            this.spanceNum = 0;
            this.getChild(ele);
          });
          this.catalogueList = response.data; //树数据源,只有根节点+children

          if (!this.catalogueActiveData.ID) {
            //树节点默认选中
            this.catalogueActiveData = response.data[0];
            this.indexName = response.data[0].IndexName;
            this.bindRightContext();
            // this.expandedKeys = [response.data[0].ID];
            this.lastKeyHighlight = response.data[0].ID;
          }
          this.setCurrentKeySelf(this.lastKeyHighlight);
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 递归获取,因为不知道children有多少层
    getChild(item) {
      const data = item;
      this.spanceNum = 0;
      this.getSpanceNum(data);
      data.space = this.spanceNum;
      if (!data.Children) {
        data.Children = [];
      }
      this.catalogueSelectList.push(data);
      data.Children.forEach((childItem) => {
        this.getChild(childItem);
      });
    },
    // 计算这个之前有多少个父结点，就要显示多少个空格
    getSpanceNum(item) {
      if (item.ParentID !== 0) {
        this.spanceNum++;
        this.getSpanceNum(
          this.catalogueSelectList[
            _.findIndex(this.catalogueSelectList, (c) => c.ID === item.ParentID)
          ]
        );
      }
    },

    // 对树节点进行筛选时执行的方法，返回 true 表示这个节点可以显示
    filterNode(value, data) {
      return data.Title.includes(value);
    },
    //点击树节点
    clickNode(data) {
      this.catalogueActiveData = data;
      this.expandedKeys = [data.ID];
      this.indexName = data.IndexName;
      this.bindRightContext();
    },
    onOpen() {},

    // 在节点中添加自定义内容，即添加，编辑，删除,功能按钮
    onRenderContent(h, { node, data }) {
      //根节点
      return (
        <div class="show-node">
          <span>
            <span title={data.Title}>{data.Title}</span>
          </span>
        </div>
      );
    },
    // 手动设置currentKey
    setCurrentKeySelf(data) {
      this.$nextTick(() => {
        this.$refs.catalogueTree.setCurrentKey(data);
      });
    },

    Popup() {
      window.open(this.catalogueActiveData.Url, '_blank');
    },


    //===================右边部分===================
    bindRightContext() {
      // 移除组件
      this.showPublishWiki = false;
      this.showWiki = false;
      this.showUrl = false;
      this.showSoftware = false;

      //文章类型 0:自定义 1:关联知识库 2:链接网页 3.程序版本
      if (this.catalogueActiveData.PublishType === 0) {
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.showPublishWiki = true;
        });
      } else if (this.catalogueActiveData.PublishType === 1) {
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.showWiki = true;
        });
      } else if (this.catalogueActiveData.PublishType === 2) {
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.showUrl = true;
        });
      } else if (this.catalogueActiveData.PublishType === 3) {
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.showSoftware = true;
        });
      }
    },

    //===================左右拉伸===================
    dragControllerDiv() {
      var resize = document.getElementsByClassName("resize");
      var left = document.getElementsByClassName("left");
      var mid = document.getElementsByClassName("mid");
      var box = document.getElementsByClassName("box");
      for (let i = 0; i < resize.length; i++) {
        // 鼠标按下事件
        resize[i].onmousedown = function (e) {
          //颜色改变提醒
          resize[i].style.background = "#818181";
          var startX = e.clientX;
          resize[i].left = resize[i].offsetLeft;
          // 鼠标拖动事件
          document.onmousemove = function (e) {
            var endX = e.clientX;
            var moveLen = resize[i].left + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
            var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

            if (moveLen < 1) moveLen = 1; // 左边区域的最小宽度为32px
            if (moveLen > maxT - 1) moveLen = maxT - 1; //右边区域最小宽度为150px

            resize[i].style.left = moveLen; // 设置左侧区域的宽度

            for (let j = 0; j < left.length; j++) {
              left[j].style.width = moveLen + "px";
              mid[j].style.width = box[i].clientWidth - moveLen - 10 + "px";
            }
          };
          // 鼠标松开事件
          document.onmouseup = function (evt) {
            //颜色恢复
            resize[i].style.background = "#d6d6d6";
            document.onmousemove = null;
            document.onmouseup = null;
            resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
          };
          resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
          return false;
        };
      }
    },
  },
};
</script>

<style lang="scss">
.wiki-part {
  height: 100%;
}
.wiki-mid {
  height: 100%;
}
.el-card::-webkit-scrollbar {     
  width: 10px;   
} 
.el-card::-webkit-scrollbar-track {     
  background: rgb(255, 255, 255);     
  border-radius: 10px; 
} 
.el-card::-webkit-scrollbar-thumb {     
  background: rgb(223, 221, 221);     
  border-radius: 10px;   
} 
.el-card::-webkit-scrollbar-thumb:hover {     
  background: rgb(189, 188, 188);     
  border-radius: 10px;   
} 
.el-card::-webkit-scrollbar-thumb:active {     
  background: rgb(153, 153, 153);     
  border-radius: 10px;   
}

// .wiki-part {
//   .el-tree-node__content {
//     position: relative;
//   }
//   .show-node {
//     flex: 1;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     padding-right: 8px;
//     font-size: 14px;
//     padding-top: 5px;
//   }
//   .adjust-btn {
//     display: none;
//     position: absolute;
//     right: 15px;
//   }
//   .show-node:hover .adjust-btn {
//     display: block;
//   }
//   .adjust-btn .el-button {
//     margin: 0;
//   }
// }
// .d-iblock {
//   display: inline-block;
// }
// .standard-search {
//   margin-right: 0.5em;
//   .el-select {
//     .el-input .el-input__inner {
//       height: 28px !important;
//     }
//     .el-select__tags,
//     .el-select__tags span {
//       white-space: nowrap;
//       overflow: hidden;
//       flex-wrap: nowrap;
//     }
//   }
//   vertical-align: middle;
// }
/* 拖拽相关样式 */
/*包围div样式*/
.box {
  width: 100%;
  height: 100%;
  margin: 0px 0px;
  overflow: hidden;
  box-shadow: -1px 9px 10px 3px rgba(0, 0, 0, 0.11);
  position: absolute;
}
/*左侧div样式*/
.left {
  width: calc(20% - 10px); /*左侧初始化宽度*/
  height: 100%;
  background: #ffffff;
  float: left;
}
/*拖拽区div样式*/
.resize {
  cursor: col-resize;
  float: left;
  position: relative;
  top: 25%;
  background-color: #d6d6d6;
  border-radius: 5px;
  margin-top: 100px;
  width: 10px;
  height: 50px;
  background-size: cover;
  background-position: center;
  /*z-index: 99999;*/
  font-size: 32px;
  color: white;
}
/*拖拽区鼠标悬停样式*/
.resize:hover {
  color: #444444;
}
/*右侧div'样式*/
.mid {
  float: left;
  width: 80%; /*右侧初始化宽度*/
  height: 100%;
  background: #fff;
  box-shadow: -1px 4px 5px 3px rgba(0, 0, 0, 0.11);
}
</style>
